import { distortA } from './distortA';

/**
 * Creates distortA effect with pseudo-random radial scatter and edge push
 * @param {number} x - X coordinate
 * @param {number} y - Y coordinate
 * @param {number} width - Canvas width
 * @param {number} height - Canvas height
 * @param {number} time - Animation time
 * @param {number} scroll - Scroll position
 * @returns {Object} Distorted point {x, y}
 */
export const distortAScatterWide = (x, y, width, height, time, scroll) => {
  // Apply base distortALight effect
  const baseDistort = distortA(x, y, width, height, time, 0.5, 0.8, scroll);

  // Calculate center
  const centerX = width / 2;
  const centerY = height / 2;
  const dx = baseDistort.x - centerX;
  const dy = baseDistort.y - centerY;
  const distance = Math.sqrt(dx * dx + dy * dy);
  const maxDistance = Math.sqrt((width / 2) ** 2 + (height / 2) ** 2);

  // Pseudo-random displacement based on coordinates
  // Uses coordinate values to generate consistent "random" values
  const seed1 = Math.sin(x * 0.01234 + y * 0.05678) * 1000;
  const seed2 = Math.cos(x * 0.03456 - y * 0.02345) * 1000;

  // Generate pseudo-random angle and magnitude
  const randomAngle = (seed1 + seed2) * 3.14159;
  const randomMagnitude = Math.abs(Math.sin(seed1) * Math.cos(seed2)) * 80;

  // Calculate scatter offset (radial push away from center)
  const scatterX = Math.cos(randomAngle) * randomMagnitude;
  const scatterY = Math.sin(randomAngle) * randomMagnitude;

  // Add radial push toward edges (stronger at edges)
  const normalizedDistance = distance / maxDistance;
  const edgePush = Math.pow(normalizedDistance, 2) * 150;
  const radialPushX = (dx / distance) * edgePush;
  const radialPushY = (dy / distance) * edgePush;

  return {
    x: baseDistort.x + scatterX + radialPushX,
    y: baseDistort.y + scatterY + radialPushY
  };
};
